import React, { Component } from 'react'
import styled from 'styled-components'
import { Loading } from '@sukiai/components'
import client from '../../../apollo'
import { SearchEMRPatient, SearchAllPatients } from '@sukiai/gql/app'
import { getFullName } from '@sukiai/utils'
// import debounce from 'lodash/debounce'
import { getAge, isCerner as isCernerEmr } from '../../../lib/util'
import omitDeep from 'omit-deep-lodash'
import search from '../../../lib/assets/icons/search.svg'

const Veil = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
`

const ModalContainer = styled.div`
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #f8f9f7;
  width: 500px;
  padding: 20px;
  position: absolute;
  top: 300px;
  z-index: 9999999;
  box-sizing: border-box;
  max-height: 500px;
`

const Header = styled.header`
  display: flex;
  align-items: center;

  h2 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-weight: 600;
  }
`

const LoadingIcon = styled.div`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 15px;
  top: 20px;
  display: ${props => (props.isLoading ? 'block' : 'none')};
`

const SearchIcon = styled.img.attrs({
  src: search
})`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 15px;
  top: 20px;
  display: ${props => (props.isLoading ? 'none' : 'block')};
`

const SearchBar = styled.input`
  width: 100%;
  padding: 10px 15px;
  font-size: 14px;
  box-sizing: border-box;
  color: black;
  outline: none;

  border: none;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);

  font-weight: 300;
  margin: 15px 0;

`

const SearchContainer = styled.div`
  width: 100%;
  position: relative;

`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: -10px;

  button {
    border: 0;
    color: #2e5f62;
    background: transparent;
    margin-left: 40px;
    font-weight: 700;
    padding: 10px 15px;
    cursor: pointer;

    &:hover {
      border-radius: 6px;
      background-color: rgba(33, 33, 33, 0.03);
    }
  }
`

const NoResults = styled.div`
  text-align: center;
  margin: 15px 0;

  
  h3 {
    margin: 5px 0;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 12px;
  }

  p {
    margin: 5px 0;
    margin-bottom: 10px;
    font-size: 12px;
  }

`

const SearchResult = styled.div`
  padding: 10px 15px;
  margin: 0 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;


  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }


  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: rgba(0, 0, 0, 0.5);
  }

  div {
    span {
      color: rgba(0, 0, 0, 0.5);
    }
    span + span::before { 
      content: ' • '; 
    }

  }
`

const displaySecondaryPatient = (patient) => {
  const age = getAge(patient.person)
  const mrn = patient?.mrn
  let gender
  if (patient.person.gender === 'MALE') {
    gender = 'M'
  } else if (patient.person.gender === 'FEMALE') {
    gender = 'F'
  }

  return (
    <div>
      {!!age && <span>{age}</span>}
      {!!gender && <span>{gender}</span>}
      {!!mrn && <span>MRN {mrn}</span>}
    </div>
  )
}

const ResultsContainer = styled.div`
    overflow-y: auto;
    width: 510px;
    margin-left: -30px;
    margin-right: -30px;
    max-height: 350px;
`

class AddPatientModal extends Component {
  state = {
    searchBy: 'NAME', // NAME or MRN
    searchQuery: '',
    madeSearch: false,
    isLoading: false,
    patients: []
  }

  handleSearchBy = (e) => {
    // reset state
    this.setState({ searchBy: e.target.value, searchQuery: '', isLoading: false, madeSearch: false, patients: [] })
  }

  onNameQueryChange = searchQuery => {
    this.setState({ searchQuery }, this.searchPatients)
  }

  searchEMRPatients = () => {
    const { searchQuery } = this.state
    const { emrType } = this.props

    // handle empty string
    if (searchQuery.trim() === '') {
      this.setState({ patients: [], madeSearch: false })
      return
    }

    this.setState({ isLoading: true })

    const variables = {
      name: '',
      mrn: searchQuery,
      emrType: emrType || 'CERNER'
    }

    client
      .query({
        query: SearchEMRPatient,
        variables: variables
      })
      .then(({ data }) => {
        const patients = data.searchEMRPatient.patients
        this.setState({ isLoading: false, patients, madeSearch: true })
      }).catch(err => {
        console.warn('Error searching for emr patient', err)
        this.setState({ isLoading: false })
      })
  }

  searchPatients = () => {
    const { searchQuery } = this.state
    const variables = {
      name: searchQuery
    }

    // handle empty string
    if (searchQuery.trim() === '') {
      this.setState({ patients: [], madeSearch: false })
      return
    }

    // set loading state
    this.setState({ isLoading: true })

    client
      .query({
        query: SearchAllPatients,
        variables: variables
      })
      .then(({ data }) => {
        const patients = data.searchPatients.results
        this.setState({ isLoading: false, patients, madeSearch: true })
      }).catch(err => {
        console.warn('Error searching for patient', err)
        this.setState({ isLoading: false, madeSearch: true })
      })
  }

  handleMRNKeyDown = (e) => {
    const searchQuery = e.target.value

    if (e.key === 'Enter') {
      this.searchEMRPatients(searchQuery)
    }
  }

  handleMRNChange = (e) => {
    const searchQuery = e.target.value
    this.setState({ searchQuery })
  }

  onSaveButtonClick = () => {
    const { searchQuery } = this.state
    this.searchPatients(searchQuery)
  }

  renderSearchComponent = () => {
    const { searchBy, searchQuery } = this.state
    if (searchBy === 'NAME') {
      return (
        <SearchBar
          type='text'
          placeholder='Enter Name'
          value={searchQuery}
          onChange={e => this.onNameQueryChange(e.target.value)}
        />
      )
    } else {
      return (
        <SearchBar
          type='text'
          placeholder='Enter MRN'
          value={searchQuery}
          onKeyDown={e => this.handleMRNKeyDown(e)}
          onChange={this.handleMRNChange}
        />
      )
    }
  }

  renderNoResults = () => {
    const { searchBy } = this.state
    if (searchBy === 'NAME') {
      return (
        <NoResults>
          <h3>No Results found for this name.</h3>
          {isCernerEmr() && <p>You can try searching by MRN.</p>}
        </NoResults>
      )
    } else if (searchBy === 'MRN') {
      return (
        <NoResults>
          <h3>No Results found</h3>
          <p>Please check the MRN and try again.</p>
        </NoResults>
      )
    }
  }

  addPatient = (patient) => {
    const { handleAddPatient, handleClose } = this.props
    const cleanedPatient = omitDeep(patient, '__typename')

    handleAddPatient(cleanedPatient)
    handleClose()
  }

  renderPatients = () => {
    const { patients } = this.state
    return (
      <ResultsContainer> {patients.map(patient => {
        const name = getFullName(patient.person)

        return (
          <SearchResult
            key={patient.id} onClick={(e) => this.addPatient(patient)}
          >
            <h2>{name}</h2>
            {displaySecondaryPatient(patient)}
          </SearchResult>
        )
      })}
      </ResultsContainer>
    )
  }

  handleSearchClick = () => {
    const { searchBy } = this.state

    if (searchBy === 'NAME') {
      this.searchPatients()
    } else {
      this.searchEMRPatients()
    }
  }

  render () {
    const { searchBy, isLoading, madeSearch, patients } = this.state
    const { handleClose } = this.props

    const isCerner = isCernerEmr()
    return (
      <Veil onClick={handleClose}>
        <ModalContainer onClick={e => e.stopPropagation()}>
          <Header>
            <h2>{isCerner ? 'Search By' : 'Search By Name'}</h2>
            {isCerner && (
              <div>
                <label>
                  <input
                    type='radio'
                    name='name'
                    value='NAME'
                    checked={searchBy === 'NAME'}
                    onChange={this.handleSearchBy}
                  />
                  Name
                </label>

                <label>
                  <input
                    type='radio'
                    name='mrn'
                    value='MRN'
                    checked={searchBy === 'MRN'}
                    onChange={this.handleSearchBy}
                  />
                  MRN
                </label>
              </div>
            )}
          </Header>

          <SearchContainer>
            <LoadingIcon isLoading={isLoading}>
              <Loading size='small' />
            </LoadingIcon>
            <SearchIcon isLoading={isLoading} />
            {this.renderSearchComponent()}
          </SearchContainer>

          {madeSearch && patients?.length === 0 && this.renderNoResults()}

          {this.renderPatients()}

          <ButtonGroup>
            <button onClick={handleClose}>CANCEL</button>
            <button onClick={this.handleSearchClick}>SEARCH</button>
          </ButtonGroup>

        </ModalContainer>
      </Veil>
    )
  }
}
export default AddPatientModal
